import React, { useEffect, useState } from "react";
import { Box, Typography, CircularProgress } from "@mui/material";
import api from "../../../services/Axios";

const Terms = () => {
  const [loading, setLoading] = useState(true);
  const [content, setContent] = useState("");

  const pickLatest = (list = []) => {
    if (!list.length) return null;
    return [...list].sort(
      (a, b) =>
        new Date(b.updatedAt || b.createdAt || 0) -
        new Date(a.updatedAt || a.createdAt || 0)
    )[0];
  };

  const loadPrivacy = async () => {
    try {
      const res = await api.get("/terms-and-condition/get-all",{baseURL:"https://dev-dj-music-api.teexponent.com/api/"});
      if (res?.data?.success) {
        const latest = pickLatest(res.data.data);
        setContent(latest?.content || "");
      }
    } catch (e) {
      console.error("Failed to load  terms and conditions");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadPrivacy();
  }, []);

  return (
    <Box
      sx={{
        minHeight: "100vh",
        background: "#0B1C2D",
        color: "#fff",
        py: 6,
        px: 2,
      }}
    >
      <Box maxWidth={900} mx="auto">
        <Typography variant="h4" sx={{ mb: 3, fontWeight: 600 }}>
          Terms & Conditions
        </Typography>

        {loading ? (
          <Box sx={{ textAlign: "center", mt: 6 }}>
            <CircularProgress />
          </Box>
        ) : content ? (
          <Box
            sx={{
              background: "#0E243F",
              borderRadius: 2,
              p: 3,
              lineHeight: 1.7,
              "& h1, & h2, & h3": { color: "#fff", mt: 3 },
              "& p": { color: "rgba(255,255,255,0.85)" },
              "& li": { color: "rgba(255,255,255,0.85)" },
              "& a": { color: "#7db2ff" },
            }}
            dangerouslySetInnerHTML={{ __html: content }}
          />
        ) : (
          <Typography sx={{ opacity: 0.7 }}>
            Terms not available.
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default Terms;
